// HeaderHamburger.tsx
// Internal AppShell chrome. Not exported. Mobile-only header affordance that
// opens the MobileNavDrawer (the desktop collapse toggle is a separate,
// always-floating button — see AppShell.tsx).

import { Button, Tooltip } from 'antd';
import { Menu } from 'lucide-react';

interface HeaderHamburgerProps {
  onOpen: () => void;
}

export function HeaderHamburger({ onOpen }: HeaderHamburgerProps) {
  return (
    <Tooltip title="Open navigation" placement="bottom">
      <Button
        type="text"
        icon={<Menu size={16} />}
        onClick={onOpen}
        aria-label="Open navigation menu"
      />
    </Tooltip>
  );
}
